import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'ADDONS_GET_ALL',
  GET_ALL_SUCCESS: 'ADDONS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'ADDONS_GET_ALL_FAILURE',
};

export const getAll = actions.getAll(() => `${BASE_URL}/addons/`, {
  PENDING: ACTIONS.GET_ALL,
  SUCCESS: ACTIONS.GET_ALL_SUCCESS,
  FAILURE: ACTIONS.GET_ALL_FAILURE,
});
